import ActionButton from './ActionButton';

const CancelButton = ({ children, onClick }) => (
  <ActionButton color="secondary" variant="outlined" onClick={ onClick }>
    {children}
  </ActionButton>
);

export default CancelButton;
